import { SciencePageContent } from '../../components/pages/science';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';

const Science = (): JSX.Element => {
  usePageVistTracker();

  return (
    <Layout
      description="We are combining music with auditory neuroscience to produce an innovative non-invasive digital therapy application."
      pageTitle="Our science"
    >
      <SciencePageContent />
    </Layout>
  );
};

export default Science;
